export const REDIRECT_LINK_LIST_ACTION = "REDIRECT_LINK_LIST_ACTION";
export const REDIRECT_LINK_LIST_SUCCESS = "REDIRECT_LINK_LIST_SUCCESS";
export const REDIRECT_LINK_LIST_FAIL = "REDIRECT_LINK_LIST_FAIL";
export const REDIRECT_LINK_DELETE_TRANSLATE_SUCCESS = "REDIRECT_LINK_DELETE_TRANSLATE_SUCCESS";

export const REDIRECT_LINK_DETAIL_ACTION = "REDIRECT_LINK_DETAIL_ACTION";
export const REDIRECT_LINK_DETAIL_DELETE_ACTION = "REDIRECT_LINK_DETAIL_DELETE_ACTION";
export const REDIRECT_LINK_DETAIL_SUCCESS = "REDIRECT_LINK_DETAIL_SUCCESS";
export const REDIRECT_LINK_DETAIL_FAIL = "REDIRECT_LINK_DETAIL_FAIL"

export const REDIRECT_LINK_DETAIL_UPDATE_ACTION = "REDIRECT_LINK_DETAIL_UPDATE_ACTION";
export const REDIRECT_LINK_DETAIL_CREATE_ACTION = "REDIRECT_LINK_DETAIL_CREATE_ACTION";
export const REDIRECT_LINK_FAIL = "REDIRECT_LINK_FAIL";